import { deriveResource } from 'pulse/resources';
import { keyBy } from '../../utils/keyBy';
import { PropertyGroups } from '../PropertyGroups';
import { stringCollator } from '../../utils/stringCollator';
import { propertiesIdentity } from '../PropertyGroups/entity';
export const PropertyDefinitions = deriveResource('hs-entities:PropertyDefinitions').from(PropertyGroups).transformToTarget(({
  sourceData
}) => sourceData.flatMap(group => {
  var _group$propertyDefini;
  return (_group$propertyDefini = group.propertyDefinitions) !== null && _group$propertyDefini !== void 0 ? _group$propertyDefini : [];
}).sort((a, b) => stringCollator.compare(a.property.label || a.property.name, b.property.label || b.property.name))).transformToSource(({
  sourceData,
  targetData
}) => {
  if (!sourceData) {
    return;
  }
  const propertiesMap = keyBy(targetData, definition => definition.property.groupName, (definition, __index, props = []) => {
    props.push(definition);
    return props;
  });
  return sourceData.map(group => Object.assign({}, group, {
    propertyDefinitions: propertiesMap[group.name]
  }));
}).withIdentity(propertiesIdentity).register();
export const PropertyDefinitionsMap = deriveResource('hs-entities:PropertyDefinitionsMap').from(PropertyDefinitions).transformToTarget(({
  sourceData
}) => keyBy(sourceData, definition => definition.property.name)).transformToSource(({
  targetData
}) => Object.values(targetData)).withIdentity(propertiesIdentity).register();
export const PropertyDefinition = deriveResource('hs-entities:PropertyDefinition').from(PropertyDefinitionsMap).mapParams(({
  objectTypeId,
  showHighlySensitiveProperties
}) => ({
  objectTypeId,
  showHighlySensitiveProperties
})).transformToTarget(({
  sourceData,
  targetParams
}) => {
  const property = sourceData[targetParams.propertyName];
  if (!property) {
    throw new Error(`Property ${targetParams.propertyName} not found`);
  }
  return property;
}).transformToSource(({
  sourceData,
  targetData,
  targetParams
}) => sourceData && Object.assign({}, sourceData, {
  [targetParams.propertyName]: targetData
})).withIdentity(params => `${propertiesIdentity(params)}-propertyName:${params.propertyName}`).register();